import classes from './CtaList.module.scss';
import Button from '../../atoms/button/Button';

const CtaList = ({ contentModule, customClass }) => {
    const { title, next_steps_ctas } = contentModule;

    return (
        <div className={`${classes.oCtaListBlock} ${classes[customClass]}`}>
            {title ? <h2 className={`${classes.aTitle} fntH2`}>{title}</h2> : null}
            <ul className={classes.oCtaList}>
                {next_steps_ctas.map((item) => (
                    <li key={item.id} className={classes.mCtaItem}>
                        <Button
                            {...item}
                            url={item.href}
                            extenderClass={item.custom_class}
                            style={item.custom_class}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CtaList;
